<!-- Multi Select Input -->
@if (name) {
  <div class="w-full"
       [class.field]="formField">
    @if (label) {
      <label
        id="{{ name }}_label"
        class="flex flex-grow-1"
        [class.mb-2]="!formField"
        for="{{ name }}">
        <span class="white-space-wrap overflow-hidden text-overflow-ellipsis">
          {{ label | translate }}
        </span>
      </label>
    }
    <p-multiSelect #multiSelect
     inputId="{{ name }}"
     appendTo="body"
     ariaLabelledBy="{{ name }}_label"
     styleClass="{{ inputClass }}"
     formControlName="{{ name }}"
     [maxSelectedLabels]="maxSelectedLabels"
     [selectedItemsLabel]="'{0} ' + ('global.selected_items_label' | translate)"
     [disableControl]="disabled"
     [options]="options"
     optionLabel="{{ optionLabel }}"
     optionValue="{{ optionValue }}"
     [filter]="(filter === undefined ? options.length >= FlatModels.DropdownDesignModels.DropDownMinFilterLimit : filter)"
     [placeholder]="placeholder | translate"
     [ngClass]="{
       'ng-invalid': control.invalid && control.touched,
       'ng-dirty': control.invalid && control.touched
     }"
     (onChange)="valueChange.emit($event)">
      <ng-template let-entry pTemplate="item">
        <div class="flex align-items-center gap-2">
          <div>{{ entry[optionLabel] | translate }}</div>
        </div>
      </ng-template>
    </p-multiSelect>
    @if (control.invalid && (control.dirty || control.touched)) {
      <br/>
      @for (err of control.errors | keyvalue; track err) {
        <small id="{{ name }}_help"
          class="p-error">
          {{ err.value | translate }}
        </small>
        <br/>
      }
    }
  </div>
}